import {apiSlice} from "./apiSlice";
import {Company} from "../../types/companyTypes";

export const companyInjectedEndpoints = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCompany: builder.query<Company, number | null | undefined>({
            query: (id): string => `/companies/${id}`,
            providesTags: ['Company']
        }),
        updateCompany: builder.mutation<Company, Company>({
            query: ({
                id,
                business_name,
                business_registration_number,
                company_size,
                dba_name,
                gst_hst_number,
                industry_code,
                name_on_contract,
                website_address,
            }) => ({
                url: `/companies/${id}`,
                method: 'PUT',
                body: {
                    business_name,
                    business_registration_number,
                    company_size,
                    dba_name,
                    gst_hst_number,
                    industry_code,
                    name_on_contract,
                    website_address,
                },
            }),
            invalidatesTags: ['Company']
        })
    })
});

export const companyEndpoints = companyInjectedEndpoints.endpoints;
export const {
    useGetCompanyQuery,
    useUpdateCompanyMutation,
} = companyInjectedEndpoints;
